import React from 'react';
import { Field, Control, Input, Icon } from 'rbx';
// import { ceil } from 'lodash';

const DiscountValueInput = ({ discountType, value, onChange, ...props }) => (
  <Field>
    <Control iconLeft>
      <Input
        type="number"
        value={value}
        min={0}
        onChange={onChange}
        {...props}
        required
        step={0.01}
      />
      <Icon align="left">{discountType === 'PRICE' ? '$' : '%'}</Icon>
    </Control>
  </Field>
);

export default DiscountValueInput;
